<div [formGroup]="form" class="mb-6 w-full">
    @if(groupName) {
        <div [formGroupName]="groupName">
            <label [for]="label" class="flex flex-col text-surface-900 dark:text-surface-0 text-xl font-medium">{{label}}</label>
            <p-inputMask mask="(999) 999-9999"   [id]="label" type="text" [placeholder]="placeholder" styleClass="mb-2" class="w-full" [formControlName]="field" trim/>
                @if (form.get(`${groupName}.${field}`)?.invalid && (form.get(`${groupName}.${field}`)?.dirty || form.get(`${groupName}.${field}`)?.touched)) {
                    <div class="alert alert-danger">
                    @if (form.get(`${groupName}.${field}`)?.hasError('required')) {
                        <p-message severity="error" variant="simple" size="small">
                            {{label}} is required.
                        </p-message>
                                            }
                    @if (form.get(`${groupName}.${field}`)?.hasError('otherTypeRequired')) {
                        <p-message severity="error" variant="simple" size="small">
                           {{label}} is required. 
                        </p-message>
                        
                    }
                    @if (form.get(`${groupName}.${field}`)?.hasError('minlength')) {
                        <p-message severity="error" variant="simple" size="small">
                                   {{label}} should have at least {{form.get(`${groupName}.${field}`)?.errors?.['minlength'].requiredLength }} characters.
                
                        </p-message>
                     }   
                    @if (form.get(`${groupName}.${field}`)?.hasError('maxlength')) {
                        <p-message severity="error" variant="simple" size="small">
                                   {{label}} should have at most {{form.get(`${groupName}.${field}`)?.errors?.['maxlength'].requiredLength }} characters.
                
                        </p-message>
                     }                              
                    </div>
                }
        </div>
    } @else {
    <label [for]="label" class="flex flex-col text-surface-900 dark:text-surface-0 text-xl font-medium">{{label}}</label>
    <p-inputMask mask="(999) 999-9999"  [id]="label" type="text" [placeholder]="placeholder" styleClass="mb-2" class="w-full" [formControlName]="field" trim/>
        @if (form.controls[field].invalid && (form.controls[field].dirty || form.controls[field].touched)) {
            <div class="alert alert-danger">
            @if (form.controls[field].hasError('required')) {
                <p-message severity="error" variant="simple" size="small">
                    {{label}} is required.
                </p-message>
                
            }
            @if (form.controls[field].hasError('otherTypeRequired')) {
                <p-message severity="error" variant="simple" size="small">
                    {{label}} is required.
                </p-message>
                
            }
            @if (form.controls[field].hasError('minlength')) {
                <p-message severity="error" variant="simple" size="small">
                                  {{label}} should have at least {{form.controls[field].errors?.['minlength'].requiredLength }} characters.  
                </p-message>

            }        
            @if (form.controls[field].hasError('maxlength')) {
                <p-message severity="error" variant="simple" size="small">
                            {{label}} should have at most {{form.controls[field].errors?.['maxlength'].requiredLength }} characters.
                
                </p-message>
            }                       
            </div>
        }
    }
</div>    

